import React from 'react';
import { filterResource as filter } from '../../functions/filterResource';
import './LayoutRow.css';

const childrenWithProps = ({ rendered, children, ...other }) => {
  if (rendered && !filter(other.resource, rendered)) {
    return <span></span>;
  }

  return React.Children.map(children,
    child => React.cloneElement(child, { ...other, ...child.props })
  );
};

const childrenWithResource = props => {
  return React.Children.map(props.children,
    child => React.cloneElement(child, {
      value: filter(props.value, child.props.name),
      error: filter(props.error, child.props.name),
      handleChange: props.handleChange,
      ...child.props,
    })
  );
};

export const Vertical = ({ style, ...other }) => (
  <div className="LayoutRow Vertical" style={style}>{childrenWithProps(other)}</div>
);

export const Horizontal = ({ style, ...other }) => (
  <div className="LayoutRow Horizontal" style={style}>{childrenWithProps(other)}</div>
);

export const VerticalInput = ({ style, ...other }) => (
  <div className="LayoutRow Vertical" style={style}>{childrenWithResource(other)}</div>
);

export const HorizontalInput = ({ style, ...other }) => (
  <div className="LayoutRow Horizontal" style={style}>{childrenWithResource(other)}</div>
);



// WEBPACK FOOTER //
// ./src/main/components/container/LayoutRow.js